<template>
  <div>
    <a-button v-if="isTrace" type="" @click="clickButton">已追踪 </a-button>
    <a-button v-else type="primary" @click="clickButton"><a-icon type="plus"></a-icon> 追踪</a-button>
    <a-modal :visible="modal.visible" :closable="false" title="绑定烯牛项目" cancelText="跳过绑定" @cancel="modalCancel" @ok="modalOk">
      <p>该公司/项目尚未绑定烯牛，可能导致追踪不准确(比如项目名称不准确等)</p>
      <ThirdCompanySelect :value="modal.selectedCompany && modal.selectedCompany.id" style="width: 100%" @change="companyChange" />
    </a-modal>
  </div>
</template>
<script>
import { isTrace, traceArtificial } from '@/api/trace.js';
import { thirdsourceBindSync } from '@/api/project.js';
import ThirdCompanySelect from '@/components/base/thirdCompanySelect';
import { Message } from 'ant-design-vue';
export default {
  components: {
    ThirdCompanySelect
  },
  props: {
    companyId: {
      type: String,
      default: ''
    },
    hasBindThridCompany: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    hasBindThridCompany(val) {
      this.oBindThridCompany = val;
    }
  },
  data() {
    return {
      isTrace: false,
      oBindThridCompany: this.hasBindThridCompany,

      modal: {
        visible: false,
        selectedCompany: undefined
      }
    };
  },
  mounted() {
    this.isTraceQuery();
  },
  methods: {
    isTraceQuery() {
      isTrace({
        companyId: this.companyId
      }).then(res => {
        if (res.code === 200) {
          this.isTrace = res.data;
        }
      });
    },
    companyChange(company) {
      this.modal.selectedCompany = company;
    },
    clickButton() {
      if (!this.oBindThridCompany && !this.isTrace) {
        this.modal.visible = true;
      } else {
        this.changeTrace();
      }
    },
    modalCancel() {
      this.modal.selectedCompany = undefined;
      this.modal.visible = false;
      this.changeTrace();
    },
    modalOk() {
      if (!this.modal.selectedCompany) {
        this.$message.warning('请选择讲要绑定的公司');
        return;
      }
      thirdsourceBindSync({
        companyId: this.companyId,
        companyCode: this.modal.selectedCompany.companyCode
      })
        .then(res => {
          if (res.code === 200) {
            this.oBindThridCompany = true;
            this.changeTrace();
            this.modal.selectedCompany = undefined;
            this.modal.visible = false;
          } else {
            throw new Error();
          }
        })
        .catch(e => {
          // this.$message.error('绑定失败');
        });
    },
    changeTrace() {
      traceArtificial({
        type: this.isTrace ? '2' : '1',
        companyIds: this.companyId
      }).then(res => {
        if (res.code === 200) {
          this.isTrace = !this.isTrace;
          if (this.isTrace) {
            this.$message.success('已成功追踪');
          } else {
            this.$message.success('已取消追踪');
          }
        }
      });
    }
  }
};
</script>
